import {
  ADMIN_USER_STORAGE_KEY,
  FEIDE_USER_STORAGE_KEY,
  STUDENT_USER_STORAGE_KEY,
  VIPPS_USER_STORAGE_KEY,
} from "../authUtils";

export function clearStoredAuthUsers() {
  localStorage.removeItem(VIPPS_USER_STORAGE_KEY);
  localStorage.removeItem(FEIDE_USER_STORAGE_KEY);
  localStorage.removeItem(ADMIN_USER_STORAGE_KEY);
  localStorage.removeItem(STUDENT_USER_STORAGE_KEY);
}

export function persistStoredUser(storageKey, user) {
  localStorage.setItem(storageKey, JSON.stringify(user));
}

export function removeStoredUser(storageKey) {
  localStorage.removeItem(storageKey);
}

export function readStoredUser(storageKey) {
  return localStorage.getItem(storageKey);
}

export function readStoredUserSnapshot() {
  return {
    adminUser: readStoredUser(ADMIN_USER_STORAGE_KEY),
    studentUser: readStoredUser(STUDENT_USER_STORAGE_KEY),
    feideUser: readStoredUser(FEIDE_USER_STORAGE_KEY),
    vippsUser: readStoredUser(VIPPS_USER_STORAGE_KEY),
  };
}
